module.exports = __webpack_public_path__ + "img/u7564.dd7710d8.svg";